module.exports = __webpack_public_path__ + "media/images/font/SofiaPro-Bold-ea3a0dfd5d31a1b871a760b2de579bcb.svg";